export default __webpack_public_path__ + "static/media/reviewsThumbnail.0029d88e.svg";